import axios from "axios";
import { API_PERSONIL_LIST_GET, API_SATUAN_GET } from "../config/api";

// digunakan di binman dan tambah user
export const getSatuanPersonilRequest = async () => {
  // const user = getLocalUser();
  try {
    const response = await axios.get(`${API_PERSONIL_LIST_GET}/satuan`, {
      headers: {
        Authorization: `bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2JhY2tlbmQuc2RpcmJpbnNlbi5jb20vYXBpL3YxL2F1dGgvbG9naW4iLCJpYXQiOjE2ODk3NDA1OTMsImV4cCI6MTY4OTgyNjk5MywibmJmIjoxNjg5NzQwNTkzLCJqdGkiOiJnQkZIUDY4OXUzNjBqWkFUIiwic3ViIjoiNSIsInBydiI6IjIzYmQ1Yzg5NDlmNjAwYWRiMzllNzAxYzQwMDg3MmRiN2E1OTc2ZjciLCJ1c2VyIjp7InVzZXJfaWQiOjUsInJvbGVfaWQiOiIxIn19.NmhGNPK-EpJfPUZMxlhl8JUiB2u4_y9K5ozPiM3uxl4`,
      },
    });
    return response.data.list_data.satuan;
  } catch (error) {
    console.error("Error fetching items:", error);
  }
};

export const getSatuanRequest = async ({ satuan_id = null, visibility = null, limit = null }) => {
  // const user = getLocalUser();
  try {
    var filter = '';

    filter += `?id=${satuan_id ?? ''}`;
    filter += `&visibility=${visibility ?? ''}`;
    filter += `&per_page=${limit ?? 100}`;

    const response = await axios.get(`${API_SATUAN_GET}${filter}`, {
      headers: {
        Authorization: `bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2JhY2tlbmQuc2RpcmJpbnNlbi5jb20vYXBpL3YxL2F1dGgvbG9naW4iLCJpYXQiOjE2ODk3NDA1OTMsImV4cCI6MTY4OTgyNjk5MywibmJmIjoxNjg5NzQwNTkzLCJqdGkiOiJnQkZIUDY4OXUzNjBqWkFUIiwic3ViIjoiNSIsInBydiI6IjIzYmQ1Yzg5NDlmNjAwYWRiMzllNzAxYzQwMDg3MmRiN2E1OTc2ZjciLCJ1c2VyIjp7InVzZXJfaWQiOjUsInJvbGVfaWQiOiIxIn19.NmhGNPK-EpJfPUZMxlhl8JUiB2u4_y9K5ozPiM3uxl4`,
      },
    });
    return response.data.list_data.satuan;
  } catch (error) {
    console.error("Error fetching items:", error);
  }
};

export const getSatuanDetailRequest = async ({ id = null }) => {
  // const user = getLocalUser();
  try {
    const response = await axios.get(`${API_SATUAN_GET}/${id}`, {
      headers: {
        Authorization: `bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2JhY2tlbmQuc2RpcmJpbnNlbi5jb20vYXBpL3YxL2F1dGgvbG9naW4iLCJpYXQiOjE2ODk3NDA1OTMsImV4cCI6MTY4OTgyNjk5MywibmJmIjoxNjg5NzQwNTkzLCJqdGkiOiJnQkZIUDY4OXUzNjBqWkFUIiwic3ViIjoiNSIsInBydiI6IjIzYmQ1Yzg5NDlmNjAwYWRiMzllNzAxYzQwMDg3MmRiN2E1OTc2ZjciLCJ1c2VyIjp7InVzZXJfaWQiOjUsInJvbGVfaWQiOiIxIn19.NmhGNPK-EpJfPUZMxlhl8JUiB2u4_y9K5ozPiM3uxl4`,
      },
    });
    return response.data.list_data.satuan;
  } catch (error) {
    console.error("Error fetching items:", error);
  }
};

export const createSatuanRequest = async ({ body = {} }) => {
  // const user = getLocalUser();
  try {
    const response = await axios.post(API_SATUAN_GET, body, {
      headers: {
        Authorization: `bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2JhY2tlbmQuc2RpcmJpbnNlbi5jb20vYXBpL3YxL2F1dGgvbG9naW4iLCJpYXQiOjE2ODk3NDA1OTMsImV4cCI6MTY4OTgyNjk5MywibmJmIjoxNjg5NzQwNTkzLCJqdGkiOiJnQkZIUDY4OXUzNjBqWkFUIiwic3ViIjoiNSIsInBydiI6IjIzYmQ1Yzg5NDlmNjAwYWRiMzllNzAxYzQwMDg3MmRiN2E1OTc2ZjciLCJ1c2VyIjp7InVzZXJfaWQiOjUsInJvbGVfaWQiOiIxIn19.NmhGNPK-EpJfPUZMxlhl8JUiB2u4_y9K5ozPiM3uxl4`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.list_data.satuan;
  } catch (error) {
    return error?.response?.data?.list_data ?? undefined;
  }
};

export const updateSatuanRequest = async ({ satuan_id = null, body = {} }) => {
  // const user = getLocalUser();
  try {
    const response = await axios.post(`${API_SATUAN_GET}/${satuan_id}`, body, {
      headers: {
        Authorization: `bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2JhY2tlbmQuc2RpcmJpbnNlbi5jb20vYXBpL3YxL2F1dGgvbG9naW4iLCJpYXQiOjE2ODk3NDA1OTMsImV4cCI6MTY4OTgyNjk5MywibmJmIjoxNjg5NzQwNTkzLCJqdGkiOiJnQkZIUDY4OXUzNjBqWkFUIiwic3ViIjoiNSIsInBydiI6IjIzYmQ1Yzg5NDlmNjAwYWRiMzllNzAxYzQwMDg3MmRiN2E1OTc2ZjciLCJ1c2VyIjp7InVzZXJfaWQiOjUsInJvbGVfaWQiOiIxIn19.NmhGNPK-EpJfPUZMxlhl8JUiB2u4_y9K5ozPiM3uxl4`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.list_data.satuan;
  } catch (error) {
    console.log(error?.response);
    return error?.response?.data?.list_data ?? undefined;
  }
};

export const deleteSatuanRequest = async ({ satuan_id = null }) => {
  // const user = getLocalUser();
  try {
    const response = await axios.delete(`${API_SATUAN_GET}/${satuan_id}`, {
      headers: {
        Authorization: `bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2JhY2tlbmQuc2RpcmJpbnNlbi5jb20vYXBpL3YxL2F1dGgvbG9naW4iLCJpYXQiOjE2ODk3NDA1OTMsImV4cCI6MTY4OTgyNjk5MywibmJmIjoxNjg5NzQwNTkzLCJqdGkiOiJnQkZIUDY4OXUzNjBqWkFUIiwic3ViIjoiNSIsInBydiI6IjIzYmQ1Yzg5NDlmNjAwYWRiMzllNzAxYzQwMDg3MmRiN2E1OTc2ZjciLCJ1c2VyIjp7InVzZXJfaWQiOjUsInJvbGVfaWQiOiIxIn19.NmhGNPK-EpJfPUZMxlhl8JUiB2u4_y9K5ozPiM3uxl4`,
      },
    });
    return response.data.list_data.satuan;
  } catch (error) {
    return error?.response?.data?.list_data ?? undefined;
  }
};
